'use client';
import React, { useState } from 'react';
import Image from 'next/image';
import '@/app/main.css';

const faqs = [
  {
    question: "What’s included in your website design and development service?",
    answer: "We handle everything from UI/UX design and responsive layouts to front-end and back-end development. Our services include custom design, content integration, CMS setup, SEO basics, and deployment — tailored to your business goals."
  },
  {
    question: "Do you build custom websites or use templates?",
    answer: "We offer both, based on your needs and budget. For a unique and branded experience, we recommend custom development. Templates are available as a faster, cost-effective option with customization to match your brand."
  },
  {
    question: "Will my website be mobile-friendly and SEO-optimized?",
    answer: "Yes. All our websites are fully responsive, ensuring they look and perform well on all devices. We also follow SEO best practices, including clean code, optimized images, meta tags, and fast load times."
  },
  {
    question: "Can I update the website myself after it’s live?",
    answer: "Absolutely. We build websites using user-friendly platforms like WordPress or custom admin panels, so you can easily manage content, add pages, and make updates without technical expertise."
  },
  {
    question: "How long does it take to design and develop a website?",
    answer: "Project timelines typically range from 1 to 4 weeks depending on the complexity, number of pages, and how quickly content is finalized. We also offer expedited delivery if you're on a tight schedule."
  },
];

function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div>
      <div
        className="col text-center py-5 mt-5"
        data-aos="fade-up"
        data-aos-delay="100"
        data-aos-duration="500"
        data-aos-once="true"
      >
        <h3>FAQ's</h3>
      </div>

      {/* Shapes */}
      <Image src="/shape1.svg" width={202} height={202} alt="shape" className="shape1" />
      <Image src="/shape2.svg" width={22} height={22} alt="shape" className="shape2 rotateme" />

      <div className="faq-area ptb-20">
        <div
          className="container"
          data-aos="fade-up"
          data-aos-delay="100"
          data-aos-duration="500"
          data-aos-once="true"
        >
          <div className="faq-accordion accordion">
            {faqs.map((item, index) => (
              <div key={index} className="accordion__item">
                <div
                  className="accordion__heading faq-heading"
                  role="heading"
                  aria-level={3}
                  data-aos="fade-up"
                  data-aos-delay="100"
                  data-aos-duration="500"
                  data-aos-once="true"
                >
                  <div
                    className="accordion__button"
                    role="button"
                    tabIndex={0}
                    onClick={() => toggleAccordion(index)}
                    aria-expanded={openIndex === index}
                    data-aos="fade-up"
                    data-aos-delay="100"
                    data-aos-duration="500"
                    data-aos-once="true"
                  >
                    <span
  className={`transition-colors duration-200 cursor-pointer 
    hover:text-purple-600 
    ${openIndex === index ? "text-purple-600 font-semibold" : ""}`}
>{item.question}</span>
                  </div>
                </div>
                {openIndex === index && (
                  <div
                    className="accordion__panel faq-ans"
                    data-aos="fade-up"
                    data-aos-delay="100"
                    data-aos-duration="500"
                    data-aos-once="true"
                  >
                    <p>{item.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default FaqSection;
